import { createReducer, on } from '@ngrx/store';
import { loadForm, saveForm, updateForm } from './formFormation.actions';

export interface FormState {
    formFormation:{
        data:{}
    }
}

export const initialFormState: FormState = {
    formFormation:{
        data:{}
    }
};

export const formFormationReducer = createReducer(
    initialFormState,

    on(loadForm, (state) => ({ ...state, loading: true })),

    on(saveForm, (state) => ({ ...state, loading: true })),

    on(updateForm, (state, data) => ({
        ...state,
        data
    }))
);